// src/pages/testimonials/Testimonials.styled.tsx
import styled from "styled-components";

export const TestimonialsContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  min-height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 2rem;
  text-align: center;
  color: #000;
`;

export const CarouselWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const CarouselViewport = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const Slides = styled.div<{ index: number }>`
  display: flex;
  transition: transform 0.3s ease;
  transform: translateX(${props => `-${props.index * 100}%`});
`;

export const Slide = styled.div`
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
  max-width: 720px;
`;

export const Name = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: #111;
  line-height: 1.25;
`;

export const Message = styled.p`
  font-size: 1rem;
  color: #444;
  line-height: 1.6;
`;

export const NavButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: #f0f0f5;
  color: #333;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #e2e2e8;
  }
`;

export const CTAContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 640px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  color: #111;
`;

export const ModalClose = styled.button`
  border: none;
  background: transparent;
  font-size: 1.25rem;
  cursor: pointer;
`;

export const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const ModalLabel = styled.label`
  display: block;
  font-size: 0.95rem;
  color: #111;
  margin-bottom: 0.4rem;
`;

export const ModalInput = styled.input<{ hasError?: boolean }>`
  padding: 0.75rem 1rem;
  border: 1px solid ${props => (props.hasError ? "#e53935" : "#e0e0e0")};
  border-radius: 8px;
  font-size: 1rem;
  width: 80%;
  max-width: 100%;
`;

export const ModalTextarea = styled.textarea<{ hasError?: boolean }>`
  padding: 0.75rem 1rem;
  border: 1px solid ${props => (props.hasError ? "#e53935" : "#e0e0e0")};
  border-radius: 8px;
  font-size: 1rem;
  min-height: 200px;
  resize: vertical;
  width: 80%;
  max-width: 100%;
`;

export const ModalSelect = styled.select<{ hasError?: boolean }>`
  padding: 0.6rem 0.9rem;
  border: 1px solid ${props => (props.hasError ? "#e53935" : "#e0e0e0")};
  border-radius: 8px;
  font-size: 1rem;
  width: 80%;
  max-width: 100%;
  background: #fff;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`;

export const ModalError = styled.span`
  display: block;
  color: #e53935;
  font-size: 0.85rem;
  margin-top: 0.4rem;
  max-width: 80%;
  word-break: break-word;
`;
